import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IPalish, IPalishInitialState } from "./palishModel";
import {
  createPalish,
  deletePalish,
  deletePalishOrderItems,
  findAllPalish,
  getPalishById,
  updatePalish,
} from "./services/palish.services";

const initialState: IPalishInitialState = {
  loading: false,
  error: "",
  PalishID: null,
  PalishOrderItemIndex: null,
  PalishOrderSelectionDialog: false,
  PalishList: [],
  PalishDetail: {
    issue_date: new Date(),
    approx_delivery_date: "",
    karigar_id: null,
    palish_order: [],
  },
  FilterPalish: {
    karigar_name: "",
    karigar_nick_name: "",
    issue_date: "",
    approx_delivery_date: "",
  },
};

const palishSlice = createSlice({
  name: "palish",
  initialState,
  reducers: {
    setPalishID: (state, action) => {
      state.PalishID = action.payload;
    },
    clearPalishDetail: (state) => {
      state.PalishDetail = initialState.PalishDetail;
    },
    setPalishOrderItemIndex: (state, action) => {
      state.PalishOrderItemIndex = action.payload;
    },
    setFilterPalish: (state, action) => {
      state.FilterPalish = action.payload;
    },
    clearFilterPalish: (state) => {
      state.FilterPalish = initialState.FilterPalish;
    },
    openPalishOrderSelectionDialog: (state) => {
      state.PalishOrderSelectionDialog = true;
    },
    closePalishOrderSelectionDialog: (state) => {
      state.PalishOrderSelectionDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllPalish.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllPalish.fulfilled,
      (state, action: PayloadAction<IPalish[]>) => {
        state.loading = false;
        state.PalishList = action.payload || [];
      }
    );
    builder.addCase(findAllPalish.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PalishList = [];
    });

    builder.addCase(createPalish.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createPalish.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createPalish.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updatePalish.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updatePalish.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updatePalish.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deletePalish.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePalish.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePalish.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getPalishById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPalishById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.PalishDetail = action.payload;
    });
    builder.addCase(getPalishById.rejected, (state, action) => {
      state.loading = false;
      state.PalishDetail = initialState.PalishDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deletePalishOrderItems.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(deletePalishOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePalishOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearPalishDetail,
  setPalishID,
  setPalishOrderItemIndex,
  clearFilterPalish,
  setFilterPalish,
  closePalishOrderSelectionDialog,
  openPalishOrderSelectionDialog,
} = palishSlice.actions;
export default palishSlice.reducer;
